/**
 * Pagination utility functions for TableAdv component
 */

/**
 * Calculate pagination values
 * @param {boolean} serverPagination - Whether server pagination is enabled
 * @param {number} page - Current page number
 * @param {number} limit - Rows per page for server pagination
 * @param {number} currentPage - Current page for client pagination
 * @param {number} rowsPerPage - Rows per page for client pagination
 * @param {Array} rows - Table data rows
 * @param {number} totalCount - Total count for server pagination
 * @returns {Object} Pagination values
 */
export const calculatePaginationValues = (
  serverPagination,
  page,
  limit,
  currentPage,
  rowsPerPage,
  rows,
  totalCount
) => {
  const startIndex = serverPagination
    ? (page - 1) * Number(limit)
    : (currentPage - 1) * rowsPerPage;

  const endIndex = serverPagination
    ? startIndex + Number(limit)
    : startIndex + rowsPerPage;

  const paginatedData = serverPagination
    ? rows
    : rows.slice(startIndex, endIndex);

  const totalPages = Math.ceil(
    (serverPagination ? totalCount : rows.length) /
      (serverPagination ? limit : rowsPerPage)
  );

  return {
    startIndex,
    endIndex,
    paginatedData,
    totalPages,
  };
};
